import { Injectable } from '@angular/core';
import { Endpoints } from 'src/environments/endpoints';
import {
  ILoginRes,
  ILoginReq,
  IUserInfoRes,
  IUpdatePassword,
} from '../model/http/security.model';
import { Observable } from 'rxjs';
import { ConsumeService } from './consume.service';
import { IGeneralResponse } from '../model/http/general-response.model';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {
  constructor(private consume: ConsumeService) {}

  login(req: ILoginReq): Observable<ILoginRes> {
    return this.consume.httpPost(Endpoints.security.login, req);
  }
  getInfoUser(): Observable<IUserInfoRes> {
    return this.consume.httpGet<IUserInfoRes>(Endpoints.security.userInfo);
  }

  updatePassword = (request: IUpdatePassword): Observable<IGeneralResponse> => {
    return this.consume.httpPost(
      `${Endpoints.security.updatePassword}`,
      request
    );
  }
}
